var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"c-player-controls",class:{
    'is-active': _vm.isActive,
    'c-player-controls--embedded': _vm.isEmbedded,
  }},[_c('div',{staticClass:"c-player-controls__top"},[_c('ui-player-age-rating'),(_vm.showEvents)?_c('ui-player-events-on-timeline'):_vm._e()],1),_c(_vm.component,{tag:"component",staticClass:"c-player-controls__bar",class:{ 'u-muted': !_vm.state.controlsEnabled }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }